import { toast } from 'react-toastify';
import ApiBase from "./base";
import i18n from "../translations";
import { jsonToQueryString } from '../shared/utils';

export const _QUIZ_URL = "quiz";

export async function getQuizList(params) {
    const response = await ApiBase.get(`${_QUIZ_URL}?${jsonToQueryString(params)}`);

    return response;
}

export async function getQuizDetail(id) {
    const response = await ApiBase.get(`${_QUIZ_URL}/${id}`);

    return response;
}

export async function createQuiz(params) {
    const response = await ApiBase.post(`${_QUIZ_URL}`, params);
    if (response.success) toast.success(i18n.t("SUCCESS_TO_CREATE_QUIZ"))

    return response;
}

export async function updateQuiz(id, params) {
    const response = await ApiBase.put(`${_QUIZ_URL}/${id}`, params);
    if (response.success) toast.success(i18n.t("SUCCESS_TO_UPDATE_QUIZ"))

    return response;
}